export class PersonaDireccionModel {
  id: number = 0;
  idPersona: number = 0;
  guidPersona: string = '';
  direccion: string = '';
  codigoPostal: string = '';
  poblacion: string = '';
  municipio: string = '';
  provincia: string = '';
  comunidadAutonoma: string = '';
  distrito: string = '';
  barrio: string = '';
  numero: string = '';
  planta: string = '';
  puerta: string = '';

  constructor() { }
}
